import { ManagementReportRepository } from '@domain/management-report/repositories/management-report.repository';
import { ManagementReportRepositoryService } from '../repositories/management-report.service';

export const ManagementReportProvider = [
  {
    provide: ManagementReportRepository,
    useClass: ManagementReportRepositoryService,
  },
];
